<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header" class="row">
            <div class="col-6">
              <h4 class="card-title f-20-mobile">Campanhas</h4>
            </div>
            <div class="col-6 text-right">
              <router-link to="/campaigns/new" class="btn btn-primary">Nova</router-link>
            </div>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Alcance</th> 
                <th>Envio</th> 
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="campaign of campaigns">
                <td>{{ campaign.name }}</td>
                <td>{{ campaign.alcance }}/{{ campaign.reach }}</td>
                <td class="text-right">
                  <router-link :to="{ path: '/campaigns/editar/' +  campaign.id, params: { userData: campaign, user: campaign } }" class="btn btn-sm btn-primary">
                    <i class="fa fa-pencil"></i>
                  </router-link>
                </td>
              </tr>
              <tr v-if="!campaigns || !campaigns.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { Card } from 'src/components'
import moment from 'moment'

import CampaignService from '@/services/CampaignService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        campaigns: [],
        total: 0,

        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.load()
      },

      filtrar() {
        this.load()
      },
      load() {
        CampaignService.load(`?page=${this.current_page}`).then(res => {
          this.pageCount = res.data.lastPage
          this.from = ((res.data.page - 1) * res.data.perPage + 1) < res.data.total ? (res.data.page - 1) * res.data.perPage + 1 : res.data.total
          this.to = (res.data.page * res.data.perPage) < res.data.total ? res.data.page * res.data.perPage : res.data.total
          this.total = res.data.total

          this.campaigns = res.data.data

          for(let campaign of res.data.data) {
            campaign.reach = campaign.notifications.length

            campaign.alcance = campaign.notifications.reduce((sum, record) => {
              return record.user_id ? sum + 1 : sum
            }, 0)
          }
        }).catch(err => {
          console.error(err)
        })
      },

      getUnidade(unidade) {
        let unidades = [  
          "UN",
          "CT",
          "CX",
          "DZ",
          "GZ",
          "PA",
          "PC",
          "PR",
          "PT",
          "RL",
          "KG",
          "G",
          "SC60",
          "L",
          "M3",
          "M2",
          "CM2",
          "M",
          "CM",
          "X"
        ]

        console.log(unidades[unidade])
        return unidades[unidade];
      },
    },
    mounted() {
      this.load()
    }
}
</script>

<style>
</style>  